// extracted by mini-css-extract-plugin
module.exports = {"container":"VkCaptcha_container__utiKH","loader":"VkCaptcha_loader__8h1OZ"};